import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { formatPlayCount } from "@/data/videos";

interface HotListProps {
  items: VideoItem[];
}

export default function HotList({ items }: HotListProps) {
  return (
    <ol className="space-y-1">
      {items.map((item, i) => (
        <li key={item.id}>
          <Link
            to={`/detail/${item.id}`}
            className="group flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span
              className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center text-sm font-heading font-bold ${
                i < 3
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {i + 1}
            </span>
            <div className="w-11 h-16 shrink-0 rounded-md overflow-hidden bg-secondary-100">
              <img
                src={item.cover}
                alt={`${item.title}封面`}
                title={`${item.title} 热播${item.type === "movie" ? "电影" : "电视剧"}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h4 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h4>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                {item.genres.slice(0, 2).join(" · ")}
              </p>
              <p className="mt-1 text-xs font-label text-accent-600 flex items-center gap-1">
                <i className="ri-fire-line"></i>
                {formatPlayCount(item.playCount)}次播放
              </p>
            </div>
            <span className="shrink-0 text-sm font-label font-semibold text-foreground-700">
              {item.rating.toFixed(1)}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}